<template>
	<modal-box @close="close" :header="$t(`buttons.actions.${params.action}_relation`)" :subHeader="$t('headers.general.watch_profile')" class="watch-profile-relation-form">
		<spinner v-if="model.loading"/>
		<error-box v-else-if="model.error" :error="model.error"/>
		<form v-else @submit.prevent="validateAndSubmit">
			<input-select v-model="model.data.relation" :options="options" name="relation_type" :placeholder="$t('labels.general.type')" rules="required"/>
			<input-text v-model="model.data.name" name="relation_name" :placeholder="$t('labels.general.name')" rules="required"/>
			<error-box v-if="form.error" :error="form.error"/>
			<div class="form-group-actions">
				<button-submit-icon-text :loading="form.loading" icon="save">{{ $t('buttons.general.save') }}</button-submit-icon-text>
			</div>
		</form>
	</modal-box>
</template>

<script>
import ApiObject from '@/classes/api/ApiObject'
export default {
	props: [
		'user_uid',
		'watch_id',
		'params'
	],
	data () {
		return {
			model: new ApiObject(),
			form: {
				loading: false,
				error: ''
			},
			options: [
				{ value: 'other', text: this.$t('categories.relations.other') },
				{ value: 'doctor', text: this.$t('categories.relations.doctor') },
				{ value: 'father', text: this.$t('categories.relations.father') },
				{ value: 'mother', text: this.$t('categories.relations.mother') },
				{ value: 'son', text: this.$t('categories.relations.son') },
				{ value: 'daughter', text: this.$t('categories.relations.daughter') }
			]
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll()
				.then(result => {
					if (result) this.submit()
				})
		},
		submit () {
			switch (this.params.action) {
				case 'add':
					this.addRelation()
					break
				case 'edit':
					this.editRelation()
					break
				default:
					this.$log.warn('watch profile relation form', 'action not set')()
			}
		},
		close (reload = false) {
			this.$emit('close', { reload })
		},
		getRelation () {
			this.model.loading = true
			this.$api.profile.relations.get(this, this.user_uid, this.watch_id, this.params.id)
				.then(response => {
					this.$log.info('watch profile relation form', 'profile.relations.get OK', response)()
					this.model.data = response.body
				}).catch(error => {
					this.$log.error('watch profile relation form', 'profile.relations.get ERROR', error)()
					this.model.error = error
				}).finally(() => {
					this.model.loading = false
				})
		},
		addRelation () {
			this.form.loading = true
			this.$api.profile.relations.add(this, this.user_uid, this.watch_id, this.model.data)
				.then(response => {
					this.$log.info('watch profile relation form', 'profile.relations.add OK', response)()
					this.close(true)
				}).catch(error => {
					this.$log.error('watch profile relation form', 'profile.relations.add ERROR', error)()
					this.form.error = error
				}).finally(() => {
					this.form.loading = false
				})
		},
		editRelation () {
			this.form.loading = true
			this.$api.profile.relations.edit(this, this.user_uid, this.watch_id, this.model.data)
				.then(response => {
					this.$log.info('watch profile relation form', 'profile.relations.edit OK', response)()
					this.close(true)
				}).catch(error => {
					this.$log.error('watch profile relation form', 'profile.relations.edit ERROR', error)()
					this.form.error = error
				}).finally(() => {
					this.form.loading = false
				})
		}
	},
	created () {
		switch (this.params.action) {
			case 'add':
				this.model.data = {
					name: '',
					relation: ''
				}
				break
			case 'edit':
				this.getRelation()
				break
			default:
				this.$log.warn('watch profile relation form', 'action not set')()
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/profile/RelationForm.vue